import React from 'react';
import './SectionSponsors.css';
import partenaireImage from '../../assets/images/partenaire.jpg';
import adeciaLogo from '../../assets/images/adecia-logo.png';

function SectionSponsors() {
    // Liste des sponsors avec leurs informations
    const sponsors = [
        {
            id: 1,
            name: "Adecia",
            logo: adeciaLogo,
            url: "https://adecia.fr/"
        }
    ];

    return (
        <section className="sponsors-section">
            <h2 className="sponsors-title">Nos Sponsors et Partenaires</h2>

            <div className="sponsors-row">
                {/* Logo Adecia (à gauche) */}
                <a
                    href="https://adecia.fr/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="sponsor-single-link"
                    aria-label="Visiter le site de Adecia"
                >
                    <img
                        src={adeciaLogo}
                        alt="Logo Adecia"
                        className="sponsor-single-logo"
                    />
                </a>

                {/* Image collective des autres partenaires (à droite) */}
                <img
                    src={partenaireImage}
                    alt="Autres sponsors et partenaires"
                    className="sponsors-full-image"
                />
            </div>
        </section>
    );
}

export default SectionSponsors;
